import OpSelect from "./index.vue";
var opselect = {
  install: function install(Vue) {
    Vue.component("OpSelect", OpSelect);
  }
};
export default opselect;